import { createFileRoute } from "@tanstack/react-router";
import InvoiceView from "../../app/views/invoice/invoiceView";

export const Route = createFileRoute("/invoice/invoice")({
  component: InvoiceView,
});
